<template>
  <div class="actions">
    <Button
      title="Limpar filtros"
      variant="info"
      size="sm"
      @onClick="clearFilters"
    >
      <i class="fa fa-eraser"></i> Limpar filtros
    </Button>

    <!-- <Button
      title="Cadastrar"
      variant="info"
      size="sm"
      @onClick="redirectToRegister"
    >
      <i class="fa fa-plus"></i> Cadastrar
    </Button> -->

    <Button
      title="Excluir"
      variant="danger"
      size="sm"
      :disabled="checkedItems.length === 0"
      @onClick="deleteItems"
    >
      <i class="fa fa-trash"></i> Excluir
    </Button>
  </div>
</template>

<script>
import Button from '../buttons/Buttons'

export default {
  name: 'Actions',
  props: {
    checkedItems: {
      type: Array,
      default: () => []
    }
  },
  components: { Button },
  methods: {
    redirectToRegister () {
      this.$router.push({
        name: this.$route.name,
        params: { type: 'cadastrar' }
      })
    },

    clearFilters () {
      this.$emit('clearFilters')
    },

    deleteItems () {
      this.$emit('deleteItems', this.checkedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  margin-bottom: 15px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/datatable/Actions.vue